import { SplashItem } from 'types'
import splashImageSrc from 'images/logos/splash-family.png'

export const baseSplashScreen: { title: string; items: SplashItem[] } = {
  title: '',
  items: [
    {
      id: '1',
      src: splashImageSrc,
    },
    {
      id: '2',
      title: '',
      paragraph: `<h2>Protect the things in life that truly matter, with our Life Cover plans</h2>`,
    },
    {
      id: '3',
      title: '',
      paragraph: `<h3>Features & benefits</h3>
        <p>
          <strong>Cover to suit your needs</strong> The choice is yours - you can choose to take out Life cover from $100k to $1m.
          You can apply for additional cover options such as Total and Permanent Disability (TPD) or Trauma cover.
        </p>
        <p>
          <strong>Quick and easy to apply online</strong> Get a quote and apply online in a few simple steps. Get a decision straight away – no medical assessment or blood tests required.
        </p>
        <p>
          <strong>Easily see your policy details</strong> Easily access your policy details at anytime using our app.
        </p>
        <p>
          <strong>Get Access to AIA Vitality</strong> a personalised scientifically-backed health and wellbeing program that supports you.
        </p>`,
    },
    {
      id: '4',
      title: '',
      paragraph: `<h4>Take a step to a healthier you with <em>AIA Vitality</em></h4>
        <p>
          When you purchase a Life Insurance provided by AIA Australia policy and your annual premium is $750 or more you can get access to <strong>AIA Vitality</strong>,
          a personalised scientifically-backed health and wellbeing program that supports you every day to make healthier lifestyle choices.
        </p>
        <p>
          It helps you understand your current state of health, provides tools to improve it and offers rewards and discounts on spa treatments, flights, gym memberships, life insurance premiums and more, to keep you motivated on your journey.
        </p>`,
    },
  ],
}
